<div
  class="overview-metric"
  [ngClass]="type"
  [ngSwitch]="label === null && data === null"
  (click)="handleCta()"
>
  <app-icon
    *ngSwitchCase="true"
    class="overmetric-loading-icon"
    [icon]="largeLoadingIcon"
  >
  </app-icon>

  <ng-container *ngSwitchDefault>
    <i2g-card class="card-content">
      <div
        class="header"
        [class.limited-access]="limitedAccessMode"
        [ngClass]="{ 'data-loading': label === null }"
        [ngSwitch]="label === null"
      >
        <app-icon *ngSwitchCase="true" [icon]="smallLoadingIcon"> </app-icon>

        <ng-container *ngSwitchDefault>
          {{ label | uppercase }}
        </ng-container>
      </div>

      <div
        *ngIf="!limitedAccessMode"
        class="data"
        [ngClass]="{ 'data-loading': data === null }"
        [ngSwitch]="data === null"
      >
        <app-icon *ngSwitchCase="true" [icon]="mediumLoadingIcon"> </app-icon>

        <ng-container *ngSwitchDefault>
          {{ data }}
        </ng-container>
      </div>
    </i2g-card>
  </ng-container>
</div>
